// 封装所有与用户相关的网络请求
import request from "@/utils/request";

// 登录接口
export function loginApi(data) {
    return request({
        url: "/auth/token",
        method: "GET",
        params: data,
    });
}

// 退出登录
export function logoutApi() {
    return request({
        url: "/auth/logout",
        method: "GET",
        params: "access_token",
    });
}
// 公司品牌切换
export function companyListApi() {
    return request({
        url: "/api/company/list",
        method: "GET",
    });
}

// 公司品牌切换
export function getUserRights(data) {
    return request({
        url: "/sys/emp/queryPermissions",
        method: "POST",
        params:data
    });
}

export function exchange(data) {
    return request({
        url: "/sys/company/exchange",
        method: "POST",
        params:data
    });
}